import { useSyncExternalStore } from 'react';

/**
 * Tiny global store for maintenance state. Driven by two sources:
 *  - the API client: any 503 `{ maintenance: true }` from a normal request flips it on
 *    (so the signal rides existing traffic — no dedicated polling while running);
 *  - the /status query: authoritative for on AND off (cold-load + recovery while paused).
 */
type MaintenanceState = { on: boolean; message: string | null };

let state: MaintenanceState = { on: false, message: null };
const listeners = new Set<() => void>();

export function setMaintenance(on: boolean, message: string | null): void {
  if (state.on === on && state.message === message) return;
  state = { on, message };
  listeners.forEach((l) => l());
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

function getSnapshot(): MaintenanceState {
  return state;
}

export function useMaintenance(): MaintenanceState {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
